<template>
    <div class="record-task">
        <input type="checkbox" :checked="check" @input="updateValue($event)">
        <span>{{ taskTypeTxt }}：</span>
        <span class="task-name">{{ taskName }}</span>
        <span class="taskLabel" :class="taskLabelColor">{{ taskLabel }}</span>
        <span>{{ updateTime }}</span>
    </div>
</template>

<script>
import { RECORD_TASK_TYPE } from '../../../data/user_record/record_task_type';
export default {
    name: "RecordTask",
    data() {
        return {
            taskType: "",
            taskName: "",
            updateTime: ""
        }
    },
    props: {
        task: Object,
        check: Boolean
    },
    mounted() {
        //console.log("task:", this.task);
        this.taskType = this.task.taskType;
        this.taskName = this.task.taskName;
        this.updateTime = this.task.updateTime;
    },
    computed: {
        taskTypeTxt() {
            switch (this.taskType) {
                case RECORD_TASK_TYPE.DELETE_CLOUD:
                    return "上傳紀錄";
                case RECORD_TASK_TYPE.DELETE_LOCAL:
                    return "下載紀錄";
                case RECORD_TASK_TYPE.UPDATE_FROM_CLOUD:
                    return "下載紀錄";
                case RECORD_TASK_TYPE.UPDATE_TO_CLOUD:
                    return "上傳紀錄";
                case RECORD_TASK_TYPE.UPLOAD_TO_CLOUD:
                    return "上傳紀錄";
                case RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD:
                    return "下載紀錄";
            }
        },
        taskLabel() {
            switch (this.taskType) {
                case RECORD_TASK_TYPE.DELETE_CLOUD:
                    return "刪除";
                case RECORD_TASK_TYPE.DELETE_LOCAL:
                    return "刪除";
                case RECORD_TASK_TYPE.UPDATE_FROM_CLOUD:
                    return "更新";
                case RECORD_TASK_TYPE.UPDATE_TO_CLOUD:
                    return "更新";
                case RECORD_TASK_TYPE.UPLOAD_TO_CLOUD:
                    return "新增";
                case RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD:
                    return "新增";
            }
        },
        taskLabelColor() {
            switch (this.taskType) {
                case RECORD_TASK_TYPE.DELETE_CLOUD:
                    return { "delete-txt": true };
                case RECORD_TASK_TYPE.DELETE_LOCAL:
                    return { "delete-txt": true };;
                case RECORD_TASK_TYPE.UPDATE_FROM_CLOUD:
                    return { "update-txt": true };
                case RECORD_TASK_TYPE.UPDATE_TO_CLOUD:
                    return { "update-txt": true };
                case RECORD_TASK_TYPE.UPLOAD_TO_CLOUD:
                    return { "upload-txt": true };
                case RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD:
                    return { "upload-txt": true };
            }
        }
    },
    methods: {
        checkItem() {
            this.check = true;
        },
        updateValue(e) {
            this.$emit('update:check', e.target.checked);
        }
    },
    emits: ["update:check"]
}
</script>

<style scoped>
.record-task {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
}

.taskLabel {
    font-weight: bolder;
}

.record-task * {
    margin: 0 0 0 1rem;
}

.upload-txt {
    color: #7dc2c1;
}

.delete-txt {
    color: #e37764;
}

.update-txt {
    color: #e6c09b;
}

.task-name {
    flex-basis: 30%;
    text-align: start;
    overflow-x: hidden;
}
</style>
